import * as React from 'react';
import { d3EmployeeChart } from '../../../interface/MyInterfaces';
import { getYears } from '../../../actions/LoadSpendingReportText';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Text, ResponsiveContainer } from 'recharts'
import { numberWithCommas } from '../../Common/Helpers';
import renderHTML from 'react-render-html';
import ZoomHelp from "./ZoomHelp";


interface ChartState {
    data?: {}[];
    clicked: Boolean;
    fill?: string;
}


export class EmployeeChart extends React.Component<d3EmployeeChart, ChartState> {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }
    handleRefresh() {
        this.setState({ clicked: false })
    }

    handleKeyUp(e) {
        if (e.key == "Enter")
            this.handleRefresh()
    }

    handleClick(data, i, e) {
        const colorLookup = getYears(data);
        const color = e.target.getAttribute("fill");
        let selectedYear;
        colorLookup.forEach(lookup => {
            if (lookup.fill === color) {
                selectedYear = lookup.year;
            }
        })
        const detailData = data[`${selectedYear}detail`];

        this.setState({
            data: detailData,
            clicked: true,
            fill: color
        })
    }

    chartText() {
        //var chart_text = this.props.SpendingReport_Tab1 && renderHTML((this.props.agg == 0) ? this.props.SpendingReport_Tab1.chart1_text : this.props.SpendingReport_Tab1.chart1_text_agg);
        var chart_text = this.props.SpendingReport_Tab1 && renderHTML(this.props.SpendingReport_Tab1.chart1_text);
        return <div style={{ paddingBottom: "0" }}>
            {chart_text}
            <p className="space"></p>
        </div>
    }
    renderBars(data, years) {
        if (this.state.clicked) {
            return <Bar fill={this.state.fill} dataKey="value" />;
        } else {
            return years.map((item, index) =>
                <Bar key={index} dataKey={item.year} fill={item.fill} onClick={this.handleClick} />
            );
        }
    }
    shortenTitle = (title) => {
        if (!title) return;
        let titleArr = title.replace(/[^a-zA-Z-\s0-9]/gi, '').replace(/-+/gi, '-').split(" ");
        titleArr = titleArr.filter((ele) => {
            return ele != "";
        });
        let newTitle = titleArr.join(" ");
        const hyphenBefore = newTitle.indexOf(" - ");
        if (hyphenBefore != -1) {
            return newTitle.substring(0, hyphenBefore);
        }
        return newTitle;
    }
    formatData = (data) => {
        //remove duplicate spaces
        //if title is too long (xxxx-xxxx-xxxx) return title before -
        return data.map((d) => {
            if (!d.title) return d;
            const title = this.shortenTitle(d.title);
            return {
                title: title.substring(0, 31),
                value: d.value
            }
        });
    }
    renderChart(data, years, dataKey) {
        var the_data = data;
        var the_years = years.sort((a, b) => { return a.year - b.year });
        var legendKey = dataKey;


        if (this.state.clicked) {
            the_data = this.state.data;
            legendKey = "title";
        }


        let margin = (this.props.normal_or_large == 0) ? { top: 10, right: 0, left: 5, bottom: 35 } :
            { top: 15, right: 0, left: 20, bottom: 45 };
        let the_fontsize = (this.props.normal_or_large == 0) ? 12 : 18;
        let axis_height = (this.props.normal_or_large == 0) ? this.state.clicked ? 80 : 45 : this.state.clicked ? 120: 70;
        let axis_angle = (this.props.normal_or_large == 0) ? -10 : -18;
        let yaxis_xpos = (this.props.normal_or_large == 0) ? -20 : -40;
        let iconSize = (this.props.normal_or_large == 0) ? 14 : 24;
        let payload = [];
        the_years.forEach((year) => {
            payload.push({ value: "FY " + year.year, type: "square", color: year.fill });
        });
        the_data = this.formatData(the_data);
        the_data = the_data.filter((d) => {
            return d.title != "";
        });
        return <ResponsiveContainer width={"100%"} height={"100%"}>
            <BarChart
                data={the_data}
                margin={margin}
                className={this.props.normal_or_large == 0 ? "normal" : "large"}
             >
                <XAxis height={axis_height}
                    dataKey={legendKey}
                    angle={axis_angle}
                    textAnchor="end"
                    tick={<this.CustomizedXAxisTick />}
                    padding={{ left: 20, right: 20 }}
                    interval={0}
                />
                <YAxis
                    tickFormatter={numberWithCommas}
                    label={{ value: "employee count", angle: -90, dx: yaxis_xpos, fontSize: the_fontsize }}
                    tick={{ fontSize: the_fontsize }} />
                <CartesianGrid stroke="#f5f5f5" />
                {<Tooltip formatter={numberWithCommas} />}
                <Legend iconType={"square"} height={10} payload={payload} iconSize={iconSize} />
                {this.renderBars(the_data, the_years)}

            </BarChart>
        </ResponsiveContainer>

    }

    CustomizedXAxisTick = props => {
        let cap = this.state.clicked ? 15 : 24;
        let legendText = props.payload.value.substring(0, cap) + (props.payload.value.length > cap ? "..." : "");
        return <g transform={`translate(${this.state.clicked ? props.x-40 : props.x},${props.y})`}>
            <Text width={20} y={this.props.normal_or_large == 0 ? this.state.clicked ? 40 : 15 : this.state.clicked ? 60: 30} fitToScale={true}
                textAnchor={"middle"} transform={this.state.clicked ? "rotate(-45)" : ""}
                verticalAnchor={"middle"}>{
                    legendText
                }
            </Text>
        </g>;

    }

    render() {
        var data = this.props.SpendingEmployeeChart_Data;
        var years = this.props.SpendingEmployeeChart_Years;
        let chart_title = this.props.SpendingReport_Tab1 && (this.props.SpendingReport_Tab1.chart1_chart_title);
        let width = (this.props.normal_or_large == 0) ? 500 : 800;
        let height = (this.props.normal_or_large == 0) ? 400 : 600;
        const chartContent = (
            <>
                {this.props.normal_or_large == 0 && <h5>{chart_title}</h5>}
                {this.props.normal_or_large == 1 && <h2>{chart_title}</h2>}
                {this.state.clicked && <i className={this.props.refresh_className} tabIndex={1} aria-hidden="true" onKeyUp={(e) => this.handleKeyUp(e)}
                    onClick={() => this.handleRefresh()}></i>}
                <div className="empchart spending-export-chart-area" style={{ width, height }}>
                    {this.props.SpendingEmployeeChart_Data && this.props.SpendingEmployeeChart_Years && this.renderChart(data, years, "occ")}
                </div>
            </>
        );
        return (
            <div style={{ height: '100%' }}>
                <div className="empchart-container">
                    {this.props.normal_or_large == 1 && <ZoomHelp className="zoomhelp zoomed" chart_no={1} />}
                    {this.props.normal_or_large == 0 && this.chartText()}
                    {this.props.exportTargetId
                        ? <div id={this.props.exportTargetId} className="spending-export-block">
                            {chartContent}
                        </div>
                        : chartContent}
                </div>
            </div>
        )
    }

}
